import { Injectable } from '@angular/core';
import { retryWhen, catchError, mergeMap, map, delay, take, delayWhen } from 'rxjs/operators';
import { Observable, throwError, timer, of } from 'rxjs';
import { EnvironmentService } from '../../enviroment/environment.service';
import { HttpClient } from '@angular/common/http';

// PROCESSING(0, "Still Processing"),
// SUCCESSFUL(1, "Successful"),
// FAILURE(2, "Failure");
@Injectable({
  providedIn: 'root'
})

export class CheckTaskStatusService {

  private envs = this.environmentService.getAllEnvs();
  private retryITNERVAL = 1000;
  private retryLIMIT = 30;
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  checkTaskStatus(taskId: string, url = this.envs.api_home): Observable<any> {
    return this.http.get<any>(`${url}/task/${taskId}`).pipe(
      retryWhen(this.genericRetryStrategy()),
      catchError(e => throwError(e))
    );
  }

  genericRetryStrategy = (maxRetryAttempts = 10, excludedStatusCodes = []) => (attempts: Observable<any>) => {
    return attempts.pipe(
      mergeMap((error, i) => {
        const retryAttempt = i + 1;
        if (
          retryAttempt > maxRetryAttempts ||
          excludedStatusCodes.find(e => e === error.status)
        ) {
          return throwError(error);
        }
        return timer(this.envs.service_retry_timer);
      })
    );
  }

  checkTaskStatus2(taskId, url = this.envs.api_home): Observable<any> {
    let count = 1;
    return this.http.get<any>(`${url}/task/${taskId}`).pipe(
      map(response => {
        if (count >= this.retryLIMIT) {
          return null;
        }
        if (response.status.id === 0 || response.status === 'OPENNED') {
          count = count + 1;
          throw response;
        }
        return response;
      }),
      retryWhen((errors: any) => {
        return errors.pipe(delayWhen((_, index) => timer(this.retryITNERVAL)), take(this.retryLIMIT));
      })
    );
  }
}
